<template>
  <div>
    <cm-activation-popup></cm-activation-popup>
  </div>
</template>

<script>
import ActivationPopup from './CMServiceActivation.vue'

export default {
  name: 'cm-service-popups',
  components: {
    'cm-activation-popup': ActivationPopup,
  }
}
</script>
